import React from 'react'
import BaseIcon from 'react-icon-base'

const Play = props => (
  <BaseIcon viewBox="0 0 8 10" {...props}>
    <g>
      <path fill="#2ED8A7" fillRule="evenodd" d="M0 0l8 5-8 5z" />
    </g>
  </BaseIcon>
)

export default Play
